import type { MailContact } from "@/lib/types/contact";

export function mailContactDisplayLabel(contact: Pick<
  MailContact,
  "email" | "displayName" | "firstName" | "lastName" | "company"
>): string {
  const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(" ").trim();
  if (fullName) return fullName;
  if (contact.displayName?.trim()) return contact.displayName.trim();
  if (contact.company?.trim()) return contact.company.trim();
  return contact.email;
}

export function mailContactAvatarLabel(contact: Pick<
  MailContact,
  "email" | "displayName" | "firstName" | "lastName" | "company"
>): string {
  return mailContactDisplayLabel(contact);
}
